import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { MainRoutingModule } from './home-routing.module'
import { MainComponent } from './home.component'
import { CoreComponentsModule } from '@core/components/core-components.module'
import { CustomHomeComponent } from '@app/custom-home/custom-home.component'
import { MasterModule } from '@app/features/master/master.module'
import { MasterVisualizarMeuCadastroComponent } from '@app/features/master/visualizar-meu-cadastro/master-visualizar-meu-cadastro.component'
import { EditMyUserComponent } from '@app/features/master/edit-my-user/edit-my-user.component'
import { ConfirmationService, MessageService } from 'primeng/api'
import { ParametersSearchSecurityPortfolioMenuComponent } from '@app/features/parameters/search-security-portfolio-menu/parameters-search-security-portfolio-menu.component'
import { authService } from '@app/core/services-api/auth.service'
import { ToastModule } from 'primeng/toast'
import { SecurityPortfolioService } from '@app/core/services-api/security-portfolio.service'

@NgModule({
  imports: [CommonModule, MainRoutingModule, CoreComponentsModule, MasterModule,
    ToastModule,],
  providers: [ConfirmationService,  authService,SecurityPortfolioService,
    MessageService],
  declarations: [MainComponent, CustomHomeComponent],
  exports: [MainComponent, CustomHomeComponent],
  entryComponents: [MasterVisualizarMeuCadastroComponent, EditMyUserComponent, ParametersSearchSecurityPortfolioMenuComponent]
})
export class MainModule { }
